import { getSessionStorage } from '@src/utils/enhancedSessionStorage'

import isBrowser from '../../utils/isBrowser'

import { InventoryResponce } from './inventory.service'

const INVENTORY_STORAGE_KEY = 'inventory_data'

type InventoryData = Record<string, InventoryResponce>

/**
 * Get inventory data from sessionStorage
 * @returns Inventory data from sessionStorage or null if not found
 */
export function getInventoryFromSessionStorage(variantId: string): InventoryResponce | null {
  if (!isBrowser()) return null

  try {
    const storage = getSessionStorage()
    return storage.getItemJSON<InventoryData>(INVENTORY_STORAGE_KEY, { isGlobal: true })?.[variantId] ?? null
  } catch (error) {
    console.error('Error getting inventory from sessionStorage:', error)
    return null
  }
}

/**
 * Store inventory data in sessionStorage
 * @param data - Inventory data to store
 */
export function setInventoryInSessionStorage(data: Record<string, InventoryResponce>): void {
  if (!isBrowser()) return

  try {
    const storage = getSessionStorage()
    storage.setItemJSON(INVENTORY_STORAGE_KEY, data, { isGlobal: true })
  } catch (error) {
    console.error('Error storing inventory in sessionStorage:', error)
  }
}
